import ViewAllStdIconAndText from "./ViewAllStdIconAndText";

export default ViewAllStdIconAndText;
